<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- errori dipendente non trovato -->
    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger2' ? 'active' : ''" *ngIf="costsList.length > 0 && findErrors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger2' ? '' : 'danger2'">{{ "EMPLOYEES_NOT_FOUND" | translate }} ({{ findErrors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger2' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of findErrors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>
    <!-- errori update -->
    <ngb-alert [type]="'danger'" [dismissible]="false" class="card w-100 mb-2" [ngClass]="openedErrorTab === 'danger1' ? 'active' : ''" *ngIf="updateErrors.length > 0">
      <h4 class="alert-heading py-1" (click)="openedErrorTab = openedErrorTab === 'danger1' ? '' : 'danger1'">{{ "ERRORS_UPDATING_COSTS" | translate }} ({{ updateErrors.length }})</h4>
      <section class="px-1" [ngClass]="openedErrorTab === 'danger1' ? 'alert-body' : 'd-none'">
        <ul class="mt-1">
          <li *ngFor="let fc of updateErrors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>
    <section>
      <div class="card">
        <div class="card-header d-block" *ngIf="costsList.length < 1">
          <p class="font-weight-bold font-medium-2 mb-0">{{ "SELECT_FILE_FOR_EMPLOYEE_COSTS" | translate }}</p>
        </div>
        <div class="card-header" *ngIf="costsList.length > 0">
          <div>
            <p class="font-weight-bold font-medium-2">{{ "CHECK_DATA_AND_SEND" | translate }}</p>
            <p>
              {{ "MONTH" | translate | titlecase }}: <strong>{{ getMonthName(month) | titlecase }}</strong>
              <br />
              {{ "YEAR" | translate | titlecase }}: <strong>{{ year }}</strong>
            </p>
          </div>
          <div class="text-right">
            <div class="mb-05">
              <a class="btn btn-outline-secondary text-secondary mr-2" (click)="reset()">{{ "RESET" | translate }}</a>
              <button type="button" class="btn btn-outline-primary" (click)="processExcelFile()">{{ "UPLOAD" | translate }}</button>
            </div>
            <small>{{ "LAST_UPDATE" | translate }}: {{ last_update }}</small>
          </div>
        </div>
        <div class="card-body pt-0" *ngIf="costsList.length < 1">
          <div class="row">
            <div class="col-lg-4">
              <fieldset>
                <div class="custom-file">
                  <input class="custom-file-input" type="file" lang="it" accept="application/vnd.sealed.xls" (change)="handlerChangeFileInput($event)" />
                  <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                  <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                </div>
              </fieldset>
            </div>
            <div class="col-lg-4">
              <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
                <select [(ngModel)]="month" id="monthYear" class="form-control pr-3 text-capitalize">
                  <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                  <option *ngFor="let month of months" [value]="month" [label]="getMonthName(month)">{{ month }}</option>
                </select>
              </label>
              <label for="years" class="mb-0 mx-1" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
                <select id="years" [(ngModel)]="year" class="form-control pr-3">
                  <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                  <option *ngFor="let year of years">{{ year }}</option>
                </select>
              </label>
              <button *ngIf="fileName" type="button" (click)="costsList = fileContent" class="btn btn-outline-primary">{{ "NEXT" | translate }}</button>
            </div>
          </div>
        </div>
        <div class="card-body px-0" *ngIf="costsList.length > 0">
          <div class="row">
            <div class="col-12">
              <ngx-datatable class="bootstrap core-bootstrap weteam-datatable" columnMode="force" [rows]="costsList" [headerHeight]="50" [scrollbarV]="true" [scrollbarH]="true" [rowHeight]="70">
                <ngx-datatable-column [name]="'COMPLETE_NAME' | translate" prop="complete_name" [sortable]="true" [width]="180">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.complete_name | titlecase }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'BADGE_NUMBER' | translate" prop="badge_number" [sortable]="true">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.badge_number }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'ORDINARY_SALARY' | translate" prop="ordinary_salary" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.ordinary_salary | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'REWARDS' | translate" prop="reward" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.reward | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'CONTRIBUTIONS' | translate" prop="contributions" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.contributions | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'TICKET_VALUE' | translate" prop="ticket_value" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.ticket_value | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'HEALTH_CARE' | translate" prop="health_care" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.health_care | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'TRANSFERS' | uppercase | translate" prop="transfers" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.transfers | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'REFUNDS' | uppercase | translate" prop="refunds" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.refunds | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'DOCUMENTED_COSTS' | uppercase | translate" prop="documented_costs" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.documented_costs | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'EXTRA_CONTRIBUTIONS' | uppercase | translate" prop="extra_contributions" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.extra_contributions | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'EXTRA_SALARY' | uppercase | translate" prop="extra_salary" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.extra_salary | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'TFR_SLICE' | uppercase | translate" prop="tfr_slice" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.tfr_slice | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'INAIL' | translate" prop="inail" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.inail | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'EMPLOYEE_COST' | translate" prop="total_cost" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.total_cost | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [name]="'SALARY_MONTH' | translate" prop="net_salary" [sortable]="false">
                  <ng-template ngx-datatable-cell-template let-row="row">{{ row.net_salary | currency: "EUR" }}</ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="costsList.length < 1">
        <div class="card-header">
          <div class="flex-basis-40">
            <h2 class="card-title">{{ "SAVED_EMPLOYEE_MONTHLY_COSTS_FOR" | translate }} {{ getMonthName(filterMonth) | titlecase }} {{ filterYear }}</h2>
            <p class="mb-0">{{ "LAST_UPDATE" | translate }}: {{ last_update }}</p>
          </div>
          <div class="flex-basis-40 d-flex justify-content-end">
            <div [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
              <input type="text" [(ngModel)]="filterSearch" (ngModelChange)="searchSavedCosts()" class="form-control" [placeholder]="'SEARCH_EMPLOYEE' | translate" />
            </div>
            <label for="filterMonth" class="mb-0 mx-1" [ngClass.sm]="'flex-basis-66'" [ngClass.md]="'flex-basis-66'">
              <select [(ngModel)]="filterMonth" id="filterMonth" class="form-control pr-3 text-capitalize">
                <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                <option *ngFor="let month of months" [value]="month" [label]="getMonthName(month)">{{ month }}</option>
              </select>
            </label>
            <label for="filterYear" class="mb-0" [ngClass.sm]="'flex-basis-33'" [ngClass.md]="'flex-basis-33'">
              <select [(ngModel)]="filterYear" id="filterYear" class="form-control pr-3">
                <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                <option *ngFor="let year of years">{{ year }}</option>
              </select>
            </label>
            <button class="btn btn-outline-primary ml-2" (click)="filterSavedCosts()">{{'SEARCH' | translate}}</button>
          </div>
        </div>
        <div class="card-body px-0 pb-0">
          <div *ngIf="filteredSavedCostsList.length < 1" class="px-2 mb-2 font-medium-1">{{ "NO_RESULTS_FOR_SELECTED_PERIOD" | translate }}</div>
          <ngx-datatable *ngIf="filteredSavedCostsList.length > 0" class="bootstrap core-bootstrap weteam-datatable" columnMode="force" [scrollbarV]="true" [scrollbarH]="true"
                         [rows]="filteredSavedCostsList" [headerHeight]="150" [rowHeight]="50" [footerHeight]="300" [sorts]="[{ prop: 'complete_name' }]">
            <ngx-datatable-column [name]="'COMPLETE_NAME' | translate" prop="complete_name" [sortable]="true" [width]="180">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.complete_name | titlecase }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ORDINARY_SALARY' | translate" prop="ordinary_salary" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.ordinary_salary | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'REWARDS' | translate" prop="reward" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.reward | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CONTRIBUTIONS' | translate" prop="contributions" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.contributions | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TICKET_VALUE' | translate" prop="ticket_value" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.ticket_value | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'HEALTH_CARE' | translate" prop="health_care" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.health_care | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TRANSFERS' | uppercase | translate" prop="transfers" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.transfers | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'REFUNDS' | uppercase | translate" prop="refunds" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.refunds | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EXTRA_CONTRIBUTIONS' | uppercase | translate" prop="extra_contributions" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.extra_contributions | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EXTRA_SALARY' | uppercase | translate" prop="extra_salary" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.extra_salary | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TFR_SLICE' | uppercase | translate" prop="tfr_slice" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.tfr_slice | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'INAIL' | translate" prop="inail" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.inail | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EMPLOYEE_COST' | translate" prop="total_cost" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.total_cost | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'SALARY_MONTH' | translate" prop="net_salary" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">{{ row.net_salary | currency: "EUR" }}</ng-template>
            </ngx-datatable-column>
            <ngx-datatable-footer>
              <ng-template ngx-datatable-footer-template>
                <div class="px-1">
                  <div class="font-weight-bold flex-basis-15 font-medium-4">{{ 'TOTAL' | translate }}</div>
                  <div
                       *ngFor="let key of ['ordinary_salary', 'reward', 'contributions', 'ticket_value', 'health_care', 'transfers', 'refunds', 'extra_contributions', 'extra_salary', 'tfr_slice', 'inail', 'total_cost', 'net_salary']">
                    <strong *ngIf="key === 'reward'">{{'REWARDS' | translate}}</strong>
                    <strong *ngIf="key === 'net_salary'">{{'SALARY_MONTH' | translate}}</strong>
                    <strong *ngIf="!['reward', 'net_salary'].includes(key)">{{key | uppercase | translate}}</strong>:
                    <span>{{ filteredSavedCostsTotals[key] | currency: 'EUR' }}</span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>
